import { Reveal } from "./Reveal";
import { SHORT_CLIPS } from "../constants/site";
import "./ShortClips.css";

const CLIP_TILES = SHORT_CLIPS.length
    ? SHORT_CLIPS
    : Array.from({ length: 6 }).map((_, i) => ({
          thumb: null,
          views: "[VIEW_COUNT]",
          key: `placeholder-${i}`,
      }));

export const ShortClips = () => {
    return (
        <section
            className="section short-clips"
            id="clips"
            data-testid="short-clips-section"
        >
            <div className="section-inner">
                <Reveal
                    as="p"
                    className="eyebrow"
                    data-testid="short-clips-label"
                >
                    Clips that travelled
                </Reveal>
                <div className="work-clips" data-testid="short-clips-row">
                    <div className="work-clips-track">
                        {Array.from({ length: 2 }).flatMap((_, copy) =>
                            CLIP_TILES.map((clip, i) => (
                                <a
                                    className="work-clip"
                                    key={`${copy}-${clip.key || i}`}
                                    href={clip.url}
                                    target="_blank"
                                    rel="noopener"
                                    data-testid={
                                        copy === 0 ? `short-clip-${i}` : undefined
                                    }
                                >
                                    {clip.thumb ? (
                                        <img
                                            className="work-clip-image"
                                            src={clip.thumb}
                                            alt="Short clip thumbnail"
                                        />
                                    ) : (
                                        <div
                                            className="work-clip-image work-media-placeholder"
                                            role="img"
                                            aria-label="[SHORT_THUMBNAIL_URL]"
                                        />
                                    )}
                                    <span className="work-clip-views">
                                        {clip.views}
                                    </span>
                                </a>
                            )),
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};
